import { ProductDocument } from '@models/product';
import React from 'react';
import DraftBanner from './DraftBanner';
import useRealTimeBids from '@util/hooks/auctions/useRealtimeBids';
import { useAuth } from 'context/AuthContext';
import { AuctionBanner } from './AuctionBanner';
import { DeletedBanner } from './DeletedBanner';

const ProductDetailsBanner = ({ product }: { product: ProductDocument }) => {
  const { userDoc } = useAuth();
  const { highestBid, usersBids } = useRealTimeBids(product.id);
  if (
    !product.date_added &&
    (product.seller_id === userDoc?.uid || userDoc?.roles?.support)
  ) {
    return <DeletedBanner />;
  }
  if (
    product.is_draft &&
    (product.seller_id === userDoc?.uid || userDoc?.roles?.support)
  ) {
    return <DraftBanner product={product} />;
  }

  if (product.is_auction && usersBids.length > 0) {
    return (
      <AuctionBanner
        winning={!!highestBid.uid && highestBid.uid === userDoc?.uid}
        isOver={product.end_time! < Date.now()}
      />
    );
  }
  return null;
};

export default ProductDetailsBanner;
